import Vue from 'vue'
import Router from 'vue-router'
import screenEnter from '@/components/screenEnter/screenEnter'
import screenIndex from '@/components/screenIndex/screenIndex'
import signIn from '@/components/signIn/signIn'
import discuss from '@/components/discuss/discuss'
import vote from '@/components/vote/vote'
import responder from '@/components/responder/responder'
import pick from '@/components/pick/pick'
import signDetail from '@/components/signDetail/signDetail'
import loadingIn from '@/components/loadingIn/loadingIn'
import screenCenter from '@/components/screenCenter/screenCenter'
import score from '@/components/score/score'
import scoreDetail from '@/components/scoreDetail/scoreDetail'
import scoreEndList from '@/components/scoreEndList/scoreEndList'
import resource from '@/components/resource/resource'
import i18n from '@/i18n'
Vue.use(Router)
export default new Router({ 
  routes: [
    {
      path: '/',
      name: 'screenEnter',
      component: screenEnter,
      meta: {
        title: i18n.t('system.ulearningScreen')
      }
    },
    {
      path: '/screenCenter',
      name: 'screenCenter',
      component: screenCenter,
      meta: {
        title: i18n.t('system.ulearningScreen')
      }
    },
    {
      path: '/loadingIn',
      name: 'loadingIn',
      component: loadingIn,
      meta: {
        title: i18n.t('system.ulearningScreen'),
        requireAuth: true, // 判断是否有Authorization
      }
    },
    {
      path: '/screenIndex',
      name: 'screenIndex',
      component: screenIndex,
      meta: {
        title: i18n.t('system.ulearningScreen'),
        requireAuth: true, // 判断是否有Authorization
      },
      children:[
        {
            path:'signIn',//点名
            name:'signIn',
            component:signIn,
            meta: {
              title: i18n.t('screen.actSign'),
              requireAuth: true, // 判断是否有Authorization
            }
        },
        {
            path:'discuss',//讨论
            name:'discuss',
            component:discuss,
            meta: {
              title: i18n.t('screen.actDiss'),
              requireAuth: true, // 判断是否有Authorization
            }
        },
        {
            path:'vote',//投票
            name:'vote',
            component:vote,
            meta: {
              title: i18n.t('screen.actVote'),
              requireAuth: true, // 判断是否有Authorization
            }
        },
        {
            path:'responder',//抢答
            name:'responder',
            component:responder,
            meta: {
              title: i18n.t('screen.actResp'),
              requireAuth: true, // 判断是否有Authorization
            }
        },
        {
          path:'pick',//选人
          name:'pick',
          component:pick,
          meta: {
            title: i18n.t('screen.actPick'),
            requireAuth: true, // 判断是否有Authorization
          }
        },
        {
          path: 'signDetail',
          name: 'signDetail',
          component: signDetail,
          meta: {
            title: i18n.t('screen.actSign'),
            requireAuth: true, // 判断是否有Authorization
          }
        },
        {
          path: 'score',
          name: 'score',
          component: score,
          meta: {
            title: i18n.t('screen.actGrade'),
            requireAuth: true, // 判断是否有Authorization
          }
        },
        {
          path: 'scoreDetail/:id',
          name: 'scoreDetail',
          component: scoreDetail,
          meta: {
            title: i18n.t('screen.actGradeDetail'),
            requireAuth: true, // 判断是否有Authorization
          }
        },
        {
          path: 'scoreEndList',
          name: 'scoreEndList',
          component: scoreEndList,
          meta: {
            title: i18n.t('screen.actGrade'),
            requireAuth: true, // 判断是否有Authorization
          }
        },
        {
          path: 'resource',
          name: 'resource',
          component: resource,
          meta: {
            title: i18n.t('screen.resource'),
            requireAuth: true, // 判断是否有Authorization
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js